import { create } from "zustand";

const useAuthStore = create((set) => ({
    email: localStorage.getItem("email") || null,
    role: localStorage.getItem("role") || null,
    token: localStorage.getItem("token") || null,
    isAuthenticated: !!localStorage.getItem("token"), // True if token exists

    // Login function
    login: (email, role, token) => {
        localStorage.setItem("email", email);
        localStorage.setItem("role", role);
        localStorage.setItem("token", token);
        set({ email, role, token, isAuthenticated: true });
    },

    // Logout function
    logout: () => {
        localStorage.removeItem("email");
        localStorage.removeItem("role");
        localStorage.removeItem("token");
        set({ email: null, role: null, token: null, isAuthenticated: false });
    },
}));

export default useAuthStore;
